// extracted by mini-css-extract-plugin
export default {"ShowSpinner":"ShowSpinner_ShowSpinner__VEpyc"};